/* eslint-disable camelcase */
import { CONFIGS } from "../configs";
import { API } from "./API";
import { getApiUrl } from "../utils/platform";

export const getBankBrands = (query) => {
  var {
    currentPage = 1,
    itemsPerPage = 20,
    sortBy = 'created_at',
    sortOrder = -1,
    search = '',
    ...filterParams
  } = query;

  console.log("[Debug] TKT1 Bank Brand query", query);

  const page = parseInt(currentPage) || 1;
  const limit = parseInt(itemsPerPage) || 20;
  const skip = (page - 1) * limit;

  let sort = {};
  const order = parseInt(sortOrder) || -1;
  sort[sortBy] = order;

  let queryString = `currentPage=${page}&itemsPerPage=${limit}&sortBy=${sortBy}&sortOrder=${order}`;

  if (search && search.trim()) {
    queryString += `&search=${encodeURIComponent(search.trim())}`;
  }

  // Add other filter parameters
  Object.keys(filterParams).forEach(key => {
    const value = filterParams[key];
    if (value !== undefined && value !== null && value !== '') {
      queryString += `&${key}=${encodeURIComponent(value)}`;
    }
  });

  return API.get(`${getApiUrl()}/api/bank-brand/get?${queryString}`);
};

export const getBankBrandByID = (id) => {
  return API.get(`${getApiUrl()}/api/bank-brand/get/${id}`);
};

export const getBankBrandByCode = (code) => {
  return API.get(`${getApiUrl()}/api/bank-brand/code/${code}`);
};

export const searchBankBrands = (query) => {
  let queryString = '';
  
  if (query && Object.keys(query).length > 0) {
    queryString = '?' + Object.keys(query)
      .filter(key => query[key] !== undefined && query[key] !== null && query[key] !== '')
      .map(key => `${key}=${encodeURIComponent(query[key])}`)
      .join('&');
  }

  return API.get(`${getApiUrl()}/api/bank-brand/search${queryString}`);
};

export const createBankBrand = (bankBrandData) => {
  return API.post(`${getApiUrl()}/api/bank-brand/`, bankBrandData);
};

export const updateBankBrand = (id, bankBrandData) => {
  return API.put(`${getApiUrl()}/api/bank-brand/${id}`, bankBrandData);
};

export const deleteBankBrand = (id) => {
  return API.delete(`${getApiUrl()}/api/bank-brand/${id}`);
};

export const getBankBrandLogos = (id) => {
  return API.get(`${getApiUrl()}/api/bank-brand/${id}/logos`);
};

export const tkt1BankBrandService = {
  getBankBrands,
  getBankBrandByID,
  getBankBrandByCode,
  searchBankBrands,
  createBankBrand,
  updateBankBrand,
  deleteBankBrand,
  getBankBrandLogos
};
